<template>
    <div class="login-dialog">
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false" width="400px" center>
            <div class="dialogitem">
                <el-input :type="loginType === 0 ? 'text' : 'text'"
                    :placeholder="loginType === 0 ? '请输入手机号/邮箱' : '请输入手机号/用户名/邮箱'" v-model="username"
                    @input="checkLength" class="num-input" maxlength="200"></el-input>
                <div v-if="loginType === 1" class="dialoglabel">(支持用户名/手机/邮箱)</div>
            </div>
            <div class="dialogitem" v-if="loginType === 1">
                <el-input placeholder="请输入密码" v-model="password" type="password" clearable show-password
                    @keyup.enter.native="handleLogin"></el-input>
            </div>
            <div class="dialogitem" v-if="loginType === 0">
                <div class="dialogiteml">
                    <el-input placeholder="请输入图形验证码" v-model="imgcode" maxlength="10"></el-input>
                </div>
                <div class="dialogitemr">
                    <div @click="refreshverification" v-html="verificationsvg" class="verification"></div>
                </div>
            </div>
            <div class="dialogitem" v-if="loginType === 0">
                <div class="dialogiteml">
                    <el-input placeholder="请输入验证码" v-model="passcode" type="number" @input="checkPLength"
                        class="num-input">></el-input>
                </div>
                <div class="dialogitemr">
                    <el-button :disabled="send" @click="aginSend">{{ content }}</el-button>
                </div>
            </div>
            <div class="dialogitem" v-if="loginType === 0 || loginType === 1">
                <el-checkbox v-model="rememberAccount" />
                <div class="dialoglabel" @click="toggleRememberAccount">{{ loginType === 0 ? '记住手机号' : '记住账号' }}</div>
            </div>
            <div class="dialogitem" v-if="loginType === 0 || loginType === 1">
                <el-checkbox v-model="checked" />
                <div class="dialoglabel" @click="toggleChecked">
                    请阅读并同意<el-link :underline="false"
                        @click.stop="openClauseDialog('service')">《用户协议》</el-link>和<el-link :underline="false"
                        @click.stop="openClauseDialog('privacy')">《隐私条款》</el-link>
                </div>
            </div>
            <div class="dialogitem">
                <el-button type="primary" @click="handleLogin" :loading="loading" :disabled="loginButtonDisabled">{{
                    loginType
                        === 0 ? '注册&登录' : '登录'
                }}</el-button>
            </div>
            <div class="dialogitem dialogfoot">
                <div v-if="loginType === 0">
                    <el-link @click="switchLoginType(1)">使用账号密码登录</el-link>
                </div>
                <div v-if="loginType === 1">
                    <el-link @click="switchLoginType(0)">使用验证码登录</el-link>
                </div>
            </div>
            <div class="dialogitem errmsg" v-show="iserrmsg">手机号或邮箱格式不正确</div>
            <div class="dialogitem errmsg" v-show="codeerrmsg">
                {{ codeerrcon }}
            </div>
        </el-dialog>

        <!-- 协议弹窗 -->
        <el-dialog :title="clauseTitle" :visible.sync="clauseDialogVisible" width="800px" center>
            <div class="clause-content" ref="clauseContent" v-html="clauseContent"></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeClauseDialog">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getUserId, saveToken } from '@/api/ai/training';
import {
    verificationLogin,
    accountLogin,
    getCodeImg,
    sendVerificationCode,
    getUserInfo,
    userRegister,
    getAgreement,
    getIP
} from '@/api/ai/login';
import md5 from 'js-md5';

export default {
    name: 'LoginDialogWeb',
    data() {
        return {
            dialogVisible: true,
            loading: false,
            loginType: 0,
            username: '',
            password: '',
            passcode: '',
            imgcode: '',
            checked: false,
            rememberAccount: true,
            send: true,
            content: '发送验证码',
            totalTime: 60,
            verification: '',
            verificationsvg: '',
            iserrmsg: false,
            codeerrmsg: false,
            codeerrcon: '',
            imgKey: '',
            ipAddress: '',
            privacyClause: '',
            serviceAgreement: '',
            clauseDialogVisible: false,
            clauseTitle: '',
            clauseContent: '',
            lastWarningTime: 0
        }
    },
    computed: {
        dialogTitle() {
            return this.loginType === 0 ? '手机/邮箱登录' : '账号登录';
        },
        loginButtonDisabled() {
            const isPhone = /^1\d{10}$/.test(this.username);
            const isEmail = /^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(this.username);
            if (this.loginType === 0) {
                return !this.passcode || this.passcode.length !== 6 || !this.username || (!isPhone && !isEmail);
            } else {
                return !this.username || !this.password;
            }
        }
    },
    watch: {
        checked(newVal) {
            try {
                localStorage.setItem('loginAgreedToTerms', newVal.toString());
            } catch (error) {
                console.error('Failed to store loginAgreedToTerms:', error);
            }
        }
    },
    mounted() {
        try {
            const storedUsername = localStorage.getItem('loginUsername');
            const storedLoginType = localStorage.getItem('loginType');
            if (storedUsername && storedLoginType) {
                this.username = storedUsername;
                this.loginType = parseInt(storedLoginType);
                this.checkLength();
            }
            const storedAgreedToTerms = localStorage.getItem('loginAgreedToTerms');
            if (storedAgreedToTerms) {
                this.checked = storedAgreedToTerms === 'true';
            }
        } catch (error) {
            console.error('Failed to load stored account information:', error);
        }
        this.initData();
    },
    beforeDestroy() {

    },
    methods: {
        async initData() {
            try {
                await this.fetchIPAddress();
                this.loadAgreementFromCache();
            } catch (error) {
                console.error('初始化数据失败:', error);
            }
        },

        loadAgreementFromCache() {
            try {
                const cachedPrivacy = localStorage.getItem('privacyClause');
                const cachedService = localStorage.getItem('serviceAgreement');
                if (cachedPrivacy) {
                    this.privacyClause = cachedPrivacy;
                }
                if (cachedService) {
                    this.serviceAgreement = cachedService;
                }
            } catch (error) {
                console.error('加载缓存协议失败:', error);
            }
        },

        async fetchIPAddress() {
            try {
                const response = await getIP();
                console.log('获取IP地址返回:', response);
                if (response && response.code === 10000) {
                    this.ipAddress = response.data;
                    console.log('获取IP地址成功:', this.ipAddress);
                    this.imgKey = md5(this.ipAddress + new Date().getTime());
                    this.refreshverification();
                }
            } catch (error) {
                console.error('获取IP地址失败:', error);
            }
        },

        async fetchAgreement(code) {
            try {
                const response = await getAgreement(code);
                if (response && response.code === 0) {
                    const content = response.data?.content || '';
                    if (code === 'PrivacyClause') {
                        this.privacyClause = content;
                        localStorage.setItem('privacyClause', content);
                    } else if (code === 'ServiceAgreement') {
                        this.serviceAgreement = content;
                        localStorage.setItem('serviceAgreement', content);
                    }
                }
            } catch (error) {
                console.error(`获取${code === 'PrivacyClause' ? '隐私协议' : '用户协议'}失败:`, error);
            }
        },

        async refreshverification() {
            try {
                const baseURL = 'https://loginf.lawxp.com/';
                const url = baseURL + 'Auth/GetCodeImg?ImgKey=' + this.imgKey;
                console.log('获取图形验证码请求URL:', url);
                const response = await getCodeImg(this.imgKey);
                this.verificationsvg = `<img src="${response}" style="width: 100%; height: 100%; cursor: pointer;" />`;
            } catch (error) {
                console.error('获取图形验证码失败:', error);
            }
        },

        checkLength() {
            this.send = true;
            const username = this.username.replace(/\s/gi, '');
            if (/^1[3456789]\d{9}$/.test(username)) {
                // 有效手机号，可发送验证码
                this.iserrmsg = false;
                if (this.totalTime == 60) {
                    this.send = false;
                }
            } else if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(username)) {
                // 邮箱格式正确，可发送验证码
                this.iserrmsg = false;
                if (this.totalTime == 60) {
                    this.send = false;
                }
            } else if (/^\d{11}$/.test(username)) {
                // 恰好11位纯数字但不是合法手机号，报错
                this.iserrmsg = true;
            } else if (username.indexOf('@') !== -1) {
                // 包含@但邮箱格式不正确，报错
                this.iserrmsg = true;
            } else {
                // 可能是用户名（大小写英文）或正在输入，不报错
                this.iserrmsg = false;
            }
        },

        checkPLength() {
            if (this.passcode.length > 6) {
                this.passcode = this.passcode.slice(0, 6);
            }
        },

        countDown() {
            this.send = true;
            this.content = this.totalTime + "s后重新发送";
            let clock = setInterval(() => {
                this.totalTime--;
                this.content = this.totalTime + "s后重新发送";
                if (this.totalTime <= 0) {
                    window.clearInterval(clock);
                    this.content = "重新发送";
                    this.totalTime = 60;
                    this.checkLength();
                }
            }, 1000);
        },

        aginSend() {
            if (this.checked) {
                const username = this.username.replace(/\s/gi, '');
                const isPhone = /^1[3456789]\d{9}$/.test(username);
                const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(username);
                if (isPhone || isEmail) {
                    const now = Date.now();
                    if (!this.imgcode) {
                        if (now - this.lastWarningTime > 3000) {
                            this.$message.error("请输入图形验证码");
                            this.lastWarningTime = now;
                        }
                        return;
                    }
                    let num = new Date().getTime();
                    let data = {
                        mobilePhone: username,
                        Phone: "",
                        Msg: "尊敬的用户，验证码：{0}，有效期10分钟，请勿泄漏给他人，如非本人操作，请忽略此消息。",
                        DeviceType: "H5",
                        Ip: this.ipAddress || "H5",
                        Time: num,
                        sign: md5(",H5," + this.ipAddress + ",," + num + "," + "JSU$E&H@F"),
                        source: 20,
                        imgCode: this.imgcode,
                        imgKey: this.imgKey
                    };
                    const baseURL = 'https://loginf.lawxp.com/';
                    const url = baseURL + 'Auth/APPSendCode';
                    console.log('发送验证码请求URL:', url);
                    console.log('发送验证码上传参数:', data);

                    sendVerificationCode(data)
                        .then((res) => {
                            console.log('发送验证码响应:', res);
                            if (res && res.code === 0) {
                                this.countDown();
                                this.$message.success('验证码发送成功');
                            } else {
                                this.refreshverification();
                                this.$message.error(res?.message || '发送验证码失败，请稍后重试');
                            }
                        })
                        .catch((err) => {
                            console.error('发送验证码失败:', err);
                            this.$message.error('发送验证码失败，请稍后重试');
                        });
                } else {
                    this.iserrmsg = true;
                }
            } else {
                const now = Date.now();
                if (now - this.lastWarningTime > 3000) {
                    this.$message.error("请先阅读并同意《用户协议》和《隐私条款》");
                    this.lastWarningTime = now;
                }
            }
        },

        switchLoginType(type) {
            this.loginType = type;
            this.password = "";
            this.passcode = "";
            this.imgcode = "";
            this.codeerrmsg = false;
            this.iserrmsg = false;
        },

        async handleLogin() {
            this.loading = true;
            try {
                if (this.loginType === 0) {
                    if (!this.checked) {
                        const now = Date.now();
                        if (now - this.lastWarningTime > 3000) {
                            this.$message.error("请先阅读并同意《用户协议》和《隐私条款》");
                            this.lastWarningTime = now;
                        }
                        this.loading = false;
                        return;
                    }
                    if (!this.imgcode) {
                        const now = Date.now();
                        if (now - this.lastWarningTime > 3000) {
                            this.$message.error("请输入图形验证码");
                            this.lastWarningTime = now;
                        }
                        this.loading = false;
                        return;
                    }
                    const baseURL = 'https://loginf.lawxp.com/';
                    const url = baseURL + 'Auth/GetTokenByPhone';
                    console.log('验证码登录请求URL:', url);

                    const num = new Date().getTime();
                    const verificationResponse = await verificationLogin({
                        mobilePhone: this.username.replace(/\s/gi, ""),
                        Phone: "",
                        Msg: "{0}",
                        DeviceType: "H5",
                        Ip: "H5",
                        Time: num,
                        sign: md5(this.passcode + ",H5,H5,," + num + "," + "JSU$E&H@F"),
                        source: 13,
                        Code: this.passcode
                    });
                    console.log('验证码登录响应:', verificationResponse);

                    if (verificationResponse && verificationResponse.code === 0) {
                        const token = verificationResponse.data.token;
                        const nickName = verificationResponse.data.nickName;
                        const userId = verificationResponse.data.userId;
                        const mobilePhone = verificationResponse.data.mobilePhone;
                        console.log('登录成功，用户ID:', userId);
                        console.log('登录成功，昵称:', nickName, mobilePhone);
                        // await this.userRegister(userId, mobilePhone, token);
                        await this.processLoginSuccess(token);
                    } else {
                        this.codeerrcon = verificationResponse?.message || '登录失败';
                        this.codeerrmsg = true;
                        this.refreshverification();
                        this.passcode = '';
                        this.imgcode = '';
                    }
                } else {
                    if (!this.checked) {
                        const now = Date.now();
                        if (now - this.lastWarningTime > 3000) {
                            this.$message.error("请先阅读并同意《用户协议》和《隐私条款》");
                            this.lastWarningTime = now;
                        }
                        this.loading = false;
                        return;
                    }
                    const baseURL = 'https://loginf.lawxp.com/';
                    const url = baseURL + 'Auth/GteTokenByAccountPwd';
                    console.log('账号密码登录请求URL:', url);

                    const loginResponse = await accountLogin({
                        ip: 'H5',
                        loginName: this.username.replace(/\s/gi, ''),
                        loginPwd: this.password,
                        loginToken: '',
                        score: 20
                    });
                    console.log('账号密码登录响应:', loginResponse);

                    if (loginResponse && loginResponse.code === 0) {
                        const token = loginResponse.data;
                        await this.processLoginSuccess(token);
                    } else {
                        this.codeerrcon = loginResponse?.message || '登录失败，请检查用户名和密码';
                        this.codeerrmsg = true;
                    }
                }
            } catch (error) {
                console.error('登录失败:', error);
                this.$message.error('登录失败，请稍后重试');
            } finally {
                this.loading = false;
            }
        },

        async processLoginSuccess(token) {
            if (this.rememberAccount) {
                try {
                    localStorage.setItem('loginUsername', this.username);
                    localStorage.setItem('loginType', this.loginType.toString());
                } catch (error) {
                    console.error('Failed to store account information:', error);
                }
            }

            const baseURL = 'https://loginf.lawxp.com/';
            const url = baseURL + 'F_UserInfo/GetUserInfoByToken';
            console.log('获取用户信息请求URL:', url);

            let tokens = { token: token };
            const headers = {
                "authorization": `Bearer ${token}`,
                "accept": "application/json, text/plain, */*",
                "accept-language": "zh,en;q=0.9",
                "cache-control": "no-cache",
                "content-type": "application/json;charset=UTF-8"
            };
            console.log('传递给getUserInfo的headers:', headers);

            const userInfoResponse = await getUserInfo(tokens, headers);
            console.log('获取用户信息:', userInfoResponse);

            if (userInfoResponse && userInfoResponse.code === 0) {
                const userInfoData = userInfoResponse.data || {};
                if (userInfoData.userId) {
                    console.log('获取到用户ID:', userInfoData.userId);
                    const longUserId = userInfoData.userId;
                    const nickname = userInfoData.nickName || '';

                    try {
                        let userIdResponse = null;
                        let retryCount = 0;
                        const maxRetries = 5;
                        const retryDelay = 3000;

                        while (retryCount < maxRetries) {
                            userIdResponse = await getUserId(longUserId);
                            if (userIdResponse && userIdResponse.data) {
                                console.log('获取到短用户ID:', userIdResponse.data);
                                break;
                            }

                            retryCount++;
                            if (retryCount < maxRetries) {
                                console.log(`获取短用户ID失败，${retryDelay / 1000}秒后第${retryCount + 1}次重试...`);
                                await new Promise(resolve => setTimeout(resolve, retryDelay));
                            }
                        }

                        if (userIdResponse && userIdResponse.data) {
                            const shortUserId = userIdResponse.data;
                            try {
                                const saveTokenData = {
                                    user_long_id: longUserId,
                                    user_short_id: shortUserId,
                                    token: `${token}`
                                };
                                const saveTokenResponse = await saveToken(saveTokenData);
                                console.log('存储 token 结果:', saveTokenResponse);

                                if (saveTokenResponse && saveTokenResponse.code == 200) {
                                    sessionStorage.setItem('electronLoginCompleted', 'true');
                                    this.$store.commit('SET_USER_ID', shortUserId);
                                    this.$store.commit('SET_USER_NAME', nickname);
                                    this.$store.commit('SET_SHOW_LOGIN_WEB_DIALOG', false);
                                    sessionStorage.setItem('fromOA', 'false');
                                    sessionStorage.setItem('userId', JSON.stringify({ id: shortUserId, longId: longUserId, userName: nickname, webSearchEnable: true }));
                                    sessionStorage.setItem('pctoken', token);
                                    try { localStorage.setItem('fromOA', 'false'); localStorage.setItem('userId', sessionStorage.getItem('userId')); localStorage.setItem('pctoken', token); localStorage.setItem('_authCachedAt', Date.now().toString()); } catch (e) {}
                                    this.$router.push({
                                        path: '/ai/chat/1',
                                        query: { newchat: 0, userId: shortUserId, login: "web" }
                                    });
                                    console.log('login URL:', window.location.href);
                                } else {
                                    console.error('存储 token 失败:', saveTokenResponse);
                                    this.refreshverification();
                                    this.passcode = '';
                                    this.imgcode = '';
                                }
                            } catch (error) {
                                console.error('调用 saveToken 接口失败:', error);
                                this.$message.error('存储用户信息失败，请稍后重试');
                                this.refreshverification();
                                this.passcode = '';
                                this.imgcode = '';
                            }
                        } else {
                            console.error('获取短用户ID失败（已尝试5次）:', userIdResponse);
                            this.$message.error('获取用户信息失败，请稍后重试');
                            this.refreshverification();
                            this.passcode = '';
                            this.imgcode = '';
                        }
                    } catch (error) {
                        console.error('调用getUserId接口失败:', error);
                        this.$message.error('获取用户信息失败，请稍后重试');
                        this.refreshverification();
                        this.passcode = '';
                        this.imgcode = '';
                    }
                } else {
                    console.error('未获取到用户ID:', userInfoData);
                    this.$message.error('未获取到用户ID，请稍后重试');
                    this.refreshverification();
                    this.passcode = '';
                    this.imgcode = '';
                }
            } else {
                this.$message.error("登录失败，请重试");
                this.refreshverification();
                this.passcode = '';
                this.imgcode = '';
            }
        },

        handleCancel() {
            this.dialogVisible = false;
        },

        async openClauseDialog(type) {
            if (type === 'privacy') {
                this.clauseTitle = '隐私协议';
                if (!this.privacyClause) {
                    await this.fetchAgreement('PrivacyClause');
                }
                this.clauseContent = this.privacyClause;
            } else if (type === 'service') {
                this.clauseTitle = '用户协议';
                if (!this.serviceAgreement) {
                    await this.fetchAgreement('ServiceAgreement');
                }
                this.clauseContent = this.serviceAgreement;
            }
            this.clauseDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.clauseContent) {
                    this.$refs.clauseContent.scrollTo({ top: 0 });
                }
            });
        },

        closeClauseDialog() {
            this.clauseDialogVisible = false;
        },

        generateRandomImgKey() {
            let result = '';
            const characters = '0123456789abcdef';
            const charactersLength = characters.length;
            for (let i = 0; i < 32; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },

        toggleChecked() {
            this.checked = !this.checked;
        },

        toggleRememberAccount() {
            this.rememberAccount = !this.rememberAccount;
        },

        async userRegister(userId, mobilePhone, token) {
            try {
                const registerData = {
                    mobilePhone: mobilePhone || "",
                    platType: 13,
                    platform: "system_web",
                    type: 41,
                    userId: userId
                };

                const headers = {
                    "authorization": `Bearer ${token}`,
                    "content-type": "application/json;charset=UTF-8"
                };

                console.log('调用注册接口，参数:', registerData);
                console.log('注册接口headers:', headers);
                console.log('注册接口URL:', 'https://im.xinfushenghuo.cn/j_user/userRegister');

                const response = await userRegister(registerData, headers);
                console.log('注册接口响应:', response);

                if (response.data) {
                    console.log('注册成功');
                } else {
                    console.error('注册失败:', response.error || '注册失败');
                }
            } catch (error) {
                console.error('调用注册接口失败:', error);
            }
        }
    }
}
</script>

<style scoped lang="less">
.num-input ::v-deep .el-input__inner[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
}

.num-input ::v-deep .el-input__inner[type="number"]::-webkit-outer-spin-button,
.num-input ::v-deep .el-input__inner[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.login-dialog {
    ::v-deep .el-dialog {
        border-radius: 8px;
    }

    ::v-deep .el-dialog__header {
        text-align: center;
        padding-top: 30px;
    }

    ::v-deep .el-dialog__title {
        font-size: 20px;
        font-weight: bold;
        color: #333;
    }

    ::v-deep .el-dialog__body {
        padding: 30px 40px;
    }

    ::v-deep .el-dialog__footer {
        padding-bottom: 30px;
    }

    .dialogitem {
        margin-bottom: 10px;
        position: relative;

        &.dialogfoot {
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;

            div {
                margin-left: 10px;
            }
        }

        &.errmsg {
            text-align: center;
            color: #f56c6c;
            font-size: 12px;
            margin-top: 0px;
        }

        &.forgot {
            text-align: right;
            margin-bottom: 10px;
        }

        &.dialogpassword {
            margin-bottom: 10px;

            .dialogpasslabel {
                font-size: 12px;
                color: #999;
                margin-top: 5px;
            }
        }
    }

    .dialogiteml {
        width: 70%;
        display: inline-block;
    }

    .dialogitemr {
        width: 28%;
        display: inline-block;
        vertical-align: top;
        margin-left: 2%;
    }

    .verification {
        width: 100%;
        height: 40px;
        cursor: pointer;
    }

    .dialoglabel {
        cursor: pointer;
        font-size: 12px;
        color: #999;
        margin-top: 5px;
    }

    /* 显式声明布局方式：防止外部全局 .el-button 规则（如 knowledge 预览页的
       display:inline-flex; align-items:center）把按钮文字挤到左边 */
    ::v-deep .el-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 40px;
        padding: 12px 2px;
        font-size: 12px;
    }

    ::v-deep .el-button>span {
        text-align: center;
        line-height: 1;
    }

    ::v-deep .el-checkbox {
        font-size: 12px;

        +.dialoglabel {
            display: inline-block;
            margin-left: 5px;
            margin-top: 0;
        }
    }

    ::v-deep .el-link {
        font-size: 12px;
    }

    .clause-content {
        max-height: 500px;
        overflow-y: auto;
        line-height: 1.5;
    }
}
</style>
